import * as React from 'react';
import { Box, ListItemButton, SxProps, Theme, Typography } from '@mui/material';
import t from '../theme';

//Icons import
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { addIconStyle, buttonBoxStyle } from '../style';

const ListItemWideButton = () => {
    return (
        <ListItemButton sx={listItemButtonStyles}>
            <Box sx={buttonBoxStyle}>
                <AddCircleOutlineIcon sx={addIconStyle} />
                <Typography variant="h4" sx={{ color: t.palette.primary.light }}>
                    Add Item
                </Typography>
            </Box>
        </ListItemButton>
    );
};

export const listItemButtonStyles: SxProps<Theme> = (t: Theme) => ({
    backgroundColor: t.palette.listItemButton.main,
    color: t.palette.primary.light,
    '&:hover': {
        backgroundColor: t.palette.listItemButton.hoverMain,
        '& .MuiListItemIcon-root': {
            color: t.palette.primary.light
        }
    }
});

export default ListItemWideButton;
